import { ComboBox } from '@simplywallst/ui-core/next';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

import { MobileField } from './MobileField';

import { PrimaryListing } from './PrimaryListing';
import { SecondaryListing } from './SecondaryListing';

import type { Props as PrimaryListingProps } from './PrimaryListing';
import type { Props as SecondaryListingProps } from './SecondaryListing';

export type Option = PrimaryListingProps | SecondaryListingProps;

interface Props {
  options: Option[];
  onSelect?: (id: string) => void;
  inputValue?: string;
  onInputChange?: (value: string) => void;
  onCancel?: () => void;
  status: 'pending' | 'success' | 'error';
}

export const TickerSearch = ({
  options,
  onSelect,
  inputValue,
  onInputChange,
  onCancel,
  status,
}: Props) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return isMobileScreen ? (
    <MobileField
      options={options}
      onSelect={onSelect}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onCancel={onCancel}
      status={status}
    />
  ) : (
    <ComboBox
      placeholder="Search for a ticker"
      options={options}
      value={inputValue}
      onSearch={onInputChange}
      onChange={(id) => onSelect?.(String(id))}
      isLoading={Boolean(Number(inputValue?.length) && status === 'pending')}
      autoFocus
    >
      {(item) => (
        <ComboBox.Option
          textValue={item.label}
          key={item.id}
          className="min-w-[380px] border-0 border-b border-solid border-subtle"
        >
          {item.type === 'primary' ? (
            <PrimaryListing {...item} />
          ) : (
            <SecondaryListing {...item} />
          )}
        </ComboBox.Option>
      )}
    </ComboBox>
  );
};
